
import { Vue, Component } from 'vue-property-decorator';
import { getAreas, save } from '../api';
import { Picker, Toast, Popup } from 'vant';
import SlideVerify from '@/components/next/SlideVerify.vue';
import { isWeiXin } from '@/common/ts/common';
import qs from 'qs';
Vue.use(Picker).use(Popup);
@Component({
  components: {
    SlideVerify,
  },
})
export default class Home extends Vue {
  showPicker: boolean = false;
  addr: any[] = [];
  columns: any[] = [];
  addrId: number = 0;
  addrValue: string = '';
  worksType: string = 'addr';
  addrText: string = '请选择地区';
  name: string = '';
  phone: string = '';
  showSlideVerify = false;
  isWeiXinCheck: any;
  udids: any = '';
  unionid: string | null = '';
  get config() {
    const conf = this.addr;
    return conf;
  }
  async mounted() {
    this.unionid = window.localStorage.getItem('unionid');
    if (!this.unionid && isWeiXin()) {
      this.WechatLogin();
    }
    this.onLoad();
  }
  onLoad() {
    this.getLocation();
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  picker() {
    this.columns = this.config;
    this.showPicker = true;
    this.worksType = 'addr';
  }
  onConfirm(value: any, index: any) {
    this.addrText = value;
    this.addrId = index + 1;
    this.addrValue = value;
    this.showPicker = false;
  }
  onCancel() {
    this.showPicker = false;
  }
  async getLocation() {
    const res: any = await getAreas();
    for (const i in res.data) {
      if (res.data[i]) {
        this.addr.push(res.data[i]);
      }
    }
  }
  fSlideData(res: any) {
      this.showSlideVerify = false;
      if (isWeiXin()) {
        this.udids = this.unionid;
      } else {
        this.udids = window.udid;
      }
      const data = {
            name: this.name,
            phone: this.phone,
            county: this.addrValue,
            appkey: window.appkey,
            udid: this.udids,
      };
      if (this.udids) {
        const lastData = Object.assign(res, data);
        save(lastData).then((result: any) =>
          this.successVote(result),
        );
      }
  }
  successVote(res: any) {
    switch (res.code) {
      case 200:
        Toast({
          type: 'success',
          duration: 1200,
          message: res.msg,
        });
        setTimeout(() => {
            location. reload();
        }, 3000);
        break;
      case 201:
        // 需要滑动验证
        this.showSlideVerify = true;
        break;
      case 203:
        if (parseFloat(window.version) >= 4.5) {
          // 需要在App内登录
          window.handleMessage('{"action":"mUserLogin","data":""}');
        } else {
          // 老版本唤起App登录页面栈
          window.location.href = 'client:logout';
        }
        break;
      case 500:
      case 204:
      case 300:
      case 100:
        Toast.fail(res.msg);
        break;
    }
  }
  sub() {
    if (!this.name) {
      Toast('请填写姓名！');
      return false;
    } else if (!this.phone) {
      Toast('请填写联系电话！');
      return false;
    } else if (!/^1[345789][0-9]{9}$/.test(this.phone)) {
      Toast('电话号码格式错误！');
      return false;
    } else if (!this.addrValue) {
      Toast('请选择地区');
      return false;
    } else {
        this.submitPerson();
      }
  }
  back() {
    window.history.back();
  }
  async submitPerson() {
    if (isWeiXin() && !window.localStorage.getItem('unionid')) {
      this.$dialog
        .confirm({
          title: '微信登录',
          message: '报名前需要进行微信登录',
        })
        .then(() => {
          console.log('确定');
          this.WechatLogin();
        })
        .catch(() => {
          console.log('取消');
        });
      return;
    }
    console.log('开始提交');
    if (isWeiXin()) {
        this.udids = this.unionid;
        this.isWeiXinCheck = 1;
    } else {
        this.udids = window.udid;
        this.isWeiXinCheck = 0;
    }
    const data = {
        name: this.name,
        phone: this.phone,
        county: this.addrValue,
        appkey: window.appkey,
        udid: this.udids,
    };
    if (this.udids) {
      const saveRes: any = await save(data);
      if (saveRes.code === 200) {
        Toast.success({duration: 3000, message: saveRes.msg});
        setTimeout(() => {
        location. reload();
        }, 3000);
      } else if (saveRes.code === 201) {
        this.showSlideVerify = true;
      } else {
        Toast.fail(saveRes.msg);
      }
    } else {
        Toast.fail('请在微信或客户端报名！');
    }
  }
}
